var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.22168,
    y: 7,
    width: 24,
    height: 2,
    rx: 1,
    transform: "rotate(45 8.22168 7)",
    fill: "#00A3A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 15.0005C28 15.0002 27.9998 15 27.9995 15C27.9992 15 27.999 15.0002 27.999 15.0005V16.9995C27.999 16.9998 27.9992 17 27.9995 17C27.9998 17 28 16.9998 28 16.9995V15.0005Z",
    fill: "#00A3A4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.80762,
    y: 23.9706,
    width: 24,
    height: 2,
    rx: 1,
    transform: "rotate(-45 6.80762 23.9706)",
    fill: "#00A3A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerClose);
export default __webpack_public_path__ + "static/media/BurgerClose.709fd6957b4043cecd23d915b8137160.svg";
export { ForwardRef as ReactComponent };